import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import Carousel from 'react-bootstrap/Carousel';



function Testimonials(props) {
	const json = props.data.allTestimonialsJson.edges

	//tesimonials.json and testimonialContent must have people in the same order..
	const testimonialContent = [
		//Shelby Wolpa
		<p className="testimonialText">Being able to visualize our org chart on ChartHop by any dimension (department, time zone, gender, squad) has empowered my team to make more <strong>strategic people decisions.</strong> <br/> Plus, the org chart being fully integrated with our HRIS makes for <strong>seamless updates</strong> and zero manual work for my team.</p>,
		//David Politis
		<p className="testimonialText">ChartHop is the perfect product in a world where <strong>remote</strong> work is the standard, where building <strong>diverse</strong> teams is critical and being <strong>agile</strong> as a business is the only way to <strong>thrive.</strong></p>,
		//David Dankenbrink
		<p className="testimonialText">I <strong>can't imagine</strong> what we'd do without ChartHop.<br/>With the auto-updated org chart, custom reporting, and real-time scenario-building, ChartHop has been a <strong>critical tool</strong> in my organization's succession planning and data comprehension.</p>,
		//Jordan Wan
		<p className="testimonialText">I’m in ChartHop almost everyday.<br/>Having an <strong>accurate, single source</strong> of employee data empowers better management decisions and employee transparency.<br/><strong>ChartHop reduces the operational hurdle</strong> of the dreaded annual planning process, allowing us to make <strong>more thoughtful personnel decisions</strong> throughout the year.</p>,
		//Alex Koykova
		<p className="testimonialText">ChartHop helped us <strong>centralize</strong> over a hundred headcount planning spreadsheets into a single platform.<br/>Now we can easily monitor people’s access, progress and consolidate multiple plans with a couple of clicks.
		</p>
	]

	return (
		<div className={"Testimonials " + (props.bgGrey ? "bgGrey" : " ")}>
			<section className={"customer testimonial-container sectionSpacing " + (props.bgGrey ? " bgGrey" : " bgWhite") }>
          			<div className="container pb-4 pt-4" >
					<Carousel controls={true}>
						{json.map((edge,index) => (
							<Carousel.Item key={edge.node.name} >
								<div className="carouselWrapper row" >
									<div className="carImageContain desktopHeadshot text-sm-center text-md-center">
										<img src={edge.node.image} alt="Author" />
									</div>
									<div className="carouselContent">
										<img src={'/home/quote.svg'} alt="" className="pb-1 pb-sm-2" />
										{testimonialContent[index]}
										<div className="div-display">
											<div className="testimonialAuthorContain" >
												<div className="carImageContain mobileHeadshot  text-center">
													<img src={edge.node.image} alt="Author" />
												</div>
												<div className="p-direction">
													<p className="testimonialAuthor mt-3">{edge.node.name}</p>
													<p className="testimonialAuthorTitle">{edge.node.title}</p>
												</div>
											</div>
											<div className="img-logo-container">
												<img src={edge.node.logo} />
											</div>
										</div>
									</div>
								</div>
							</Carousel.Item>
						))}
					</Carousel>
				</div>
			</section>
		</div>
	);
}



export default function TestimonialsQueried(props) {
  return (
    <StaticQuery
      query={graphql`
		query {
		  allTestimonialsJson {
		    edges {
		      node {
		        id
		        name
		        title
		        image
		        logo
		      }
		    }
		  }
		}
      `}
      render={data => <Testimonials data={data} {...props}/> }
    />
  )
}